<!-- 高频电磁场 -->
<template>
  <div class="tableBoxShadow">
    <h5 :class="['title',{mobileFontSize:$isMobile}]">{{tableData[0]&&tableData[0].desc}}</h5>
    <el-table :class="{mobileTable:$isMobile}" border :data="tableData" style="width: 100%">
      <el-table-column align="center" prop="hz" label="频率（f，MHz）">
      </el-table-column>
      <el-table-column align="center" prop="electricIntensity" label="电场强度（V/m）">
      </el-table-column>
      <el-table-column align="center" prop="magneticIntensity" label="磁场强度（A/m）">
        <template slot-scope='scope'>
          <p>{{scope.row.magneticIntensity?scope.row.magneticIntensity:'-'}}</p>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        tableData:[]
      }
    },
    created() {
      this.findHighFrequencyElectromagnetic()
    },
    methods:{
      async findHighFrequencyElectromagnetic(){
        let res = await this.$axios.get(this.$serviceAPI.findHighFrequencyElectromagnetic)
        this.tableData = res.data.data
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/subPage/highFrequencyElectromagnetic.vue